<template lang="pug">
.section-header
	p.section-header__heading {{ heading }}
	.section-header__social-icons
		a(v-for="(icon, i) in iconClasses" :href="posts[i].poster_url" target="_blank" :key="posts[i].id").section-header__social-icon
			i(:class="icon")
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: 'Header',
	data() {
		return {
			heading: this.$root.mainHeading
		}
	},
	computed: {
		...mapGetters(["socialData"]),
		posts() {
			return [this.socialData.posts.items[0], this.socialData.posts.items[1]];
		},
		iconClasses() {
			if (this.posts[0].source.source === this.posts[1].source.source) {
				return ["blue-icon-" + this.posts[0].source.source.toLowerCase()];
			} else {
				return ["blue-icon-" + this.posts[0].source.source.toLowerCase(), "blue-icon-" + this.posts[1].source.source.toLowerCase()];
			}
		}
	},
	methods: {},
	mounted() {
		
	}
}
</script>
